import jsPDF from "jspdf";
import { PrintDataEntitas } from "@/domain/entities/Booking";
import { renderTopTerms, renderBottomTerms } from "./footer/terms";
import { renderFooterHeader } from "./footer/header";
import { renderFooterBox } from "./footer/box";

export const footerSectionV3 = async (
  params: {
    doc: jsPDF | any;
    bookingType: string;
    accountType: string;
    data: PrintDataEntitas;
    pieceData: any;
    barcode: string;
    vendorRefCode: string;
    barcodeValue: string;
    vendorRefCodeValue: string;
    logo: string;
    shipmentId: string;
    startX: number;
    startY: number;
  },
  logoAspectRatio: number,
  translate: Function,
  language = "id"
) => {
  const baseX = params.startX;
  const baseY = params.startY;
  const footerTopY = baseY + 108;
  const headerSeparatorY = footerTopY + 18;

  const { leftMargin, rightMargin } = renderTopTerms({
    doc: params.doc,
    baseX,
    baseY,
    translate
  });

  renderFooterHeader({
    doc: params.doc,
    baseX,
    footerTopY,
    headerSeparatorY,
    leftMargin,
    logoAspectRatio,
    data: params.data,
    barcodeValue: String(params.barcodeValue || ""),
    shipmentId: String(params.shipmentId || ""),
    language,
    translate,
    // woodpackingDisplay: params.woodpackingDisplay
  });

  const { boxY, boxH } = await renderFooterBox({
    doc: params.doc,
    baseX,
    headerSeparatorY,
    leftMargin,
    bookingType: params.bookingType,
    accountType: params.accountType,
    data: params.data,
    translate
  });

  renderBottomTerms({
    doc: params.doc,
    leftMargin,
    rightMargin,
    bottomTermsY: boxY + boxH + 2.2,
    translate
  });
};
